"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplacesDetailEnum = exports.ReplacesSummaryEnum = void 0;
var ReplacesSummaryEnum;
(function (ReplacesSummaryEnum) {
})(ReplacesSummaryEnum = exports.ReplacesSummaryEnum || (exports.ReplacesSummaryEnum = {}));
var ReplacesDetailEnum;
(function (ReplacesDetailEnum) {
    ReplacesDetailEnum["DURATION"] = "{DURATION}";
    ReplacesDetailEnum["MAX"] = "{MAX}";
})(ReplacesDetailEnum = exports.ReplacesDetailEnum || (exports.ReplacesDetailEnum = {}));
